import {CodeRepository,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {Stack} from '@mantine/core';


export const Profile = ({record}: { record: CodeRepository }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'Provider',
            value: record.provider as string,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'Default Branch',
            value: record.defaultBranch as string,
            span: 12,
        }, {
            label: 'Clone URL (HTTP)',
            value: record.cloneUrlHttp as string,
            span: 12,
        }, {
            label: 'Clone URL (SSH)',
            value: record.cloneUrlSsh as string,
            span: 12,
        }, {
            label: 'ARN',
            value: record.arn as string,
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
        </Stack>
    );


};
